import { useEffect } from 'react';
import { useReplicateClient } from '@/shared/hooks/useReplicateClient';
import { useSettings } from '@/shared/hooks/useSettings';
import { jobScheduler } from './scheduler';
import { recoverInterruptedJobs } from './recovery';

/**
 * Mount this once at the application root. It:
 *  - sweeps any job left in 'running' state from a previous session,
 *  - starts the scheduler's liveQuery loop,
 *  - keeps the scheduler's context (client + concurrencyCap) in sync.
 */
export function useSchedulerBootstrap(): void {
  const client = useReplicateClient();
  const [settings] = useSettings();

  useEffect(() => {
    void recoverInterruptedJobs().catch((err: unknown) => {
      console.error('Job recovery failed', err);
    });
    jobScheduler.start();
    return () => jobScheduler.stop();
  }, []);

  useEffect(() => {
    if (!client) {
      jobScheduler.setContext(null);
      return;
    }
    jobScheduler.setContext({ client, concurrencyCap: settings.concurrencyCap });
  }, [client, settings.concurrencyCap]);
}
